const serve = '/api'

export default [
	{
		name: 'addFileStorage',
		method: 'post',
		url: serve + '/file-storage',
		params: {},
		docs: '素材新建'
	}
]
